export default {
    A1: {
        t: 's',
        v: '',
    },
    A2: {
        t: 's',
        v: '',
    },
    H2: {
        t: 's',
        v: '',
    },
    A3: {
        t: 's',
        v: '科目代號',
    },
    B3: {
        t: 's',
        v: '科目名稱',
    },
    C3: {
        t: 's',
        v: '科目屬性',
    },
    D3: {
        t: 's',
        v: '傳票日期',
    },
    E3: {
        t: 's',
        v: '傳票號碼',
    },
    F3: {
        t: 's',
        v: '摘要',
    },
    G3: {
        t: 's',
        v: '借方金額',
    },
    H3: {
        t: 's',
        v: '貸方金額',
    },
    I3: {
        t: 's',
        v: '餘額',
    },
    '!ref': 'A1:I3',
    '!merges': [
        { s: { c: 0, r: 0 }, e: { c: 8, r: 0 } },
        { s: { c: 7, r: 1 }, e: { c: 8, r: 1 } },
        { s: { c: 0, r: 1 }, e: { c: 6, r: 1 } },
    ],
};
